import type { FaireProductEntity } from "../../entity_types/product";

export const p_aa34b8d4m9: FaireProductEntity = {
  token: "p_aa34b8d4m9",
  type: "product",
  name: "Minimalist Multi-Layer Gold Plated Necklace DP25E807",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/8749ea735dd713cce6c8a3766e866fbb056fa7840ced58a2f597965c1d2c931e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98d9e01c4a98a22492f2963b020e05ee8e10739c8d42939166b6a9dc5c34ab35.jpeg",
    "https://cdn.faire.com/fastly/0026572c0ec5ad2d9e1739744d91e4760d99122a51c92cd0457f07b94a001988.jpeg",
    "https://cdn.faire.com/fastly/a59c45ab5efba914a735eb49effdae1b747353ce267536812250acdc0ad1f0fd.jpeg",
  ],
  priceDollars: 20.49,
  description:
    "Feature:\n * Multi-Layer\n * Geometric\n * Gold Plated\n * Lightweight\n * Adjustable\n * Simple, Versatile, Delicate \n * Daily Fitting\n * Gift\n\n Weigh:\n * 10g\n\n Material:\n * Copper\n\n Package:\n * Package include 1 necklace.\n\n Note:\n * Avoid contact water, perfumes, and chemicals. Store in a dry, cool place and keep away from direct sunlight.\n * Remove before swimming, bathing, or exercising.\n * To clean, gently wipe with a soft, dry cloth.",
  tags: [],
  msrpDollars: 40.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:57.063Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
